import { Layers } from '@3ddv/ngx-sites-builder-lib';
import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';

@Component({
  selector: 'app-sbeditor-tool-layers',
  templateUrl: './layers.component.html',
  styleUrls: ['./layers.component.scss']
})
export class LayersComponent {
  private subscriptions: Subscription[];
  public tool: Layers;

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.layers) {
        this.tool = JSON.parse(JSON.stringify(res.layers));
        // console.log('Layers tool: ', this.tool);
      } else {
        console.error('layers tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public getTool(){
    return this.tool;
  }

  public switchDisplayLevel(layer: 'sections' | 'seats'){
    this.tool.layerLevel = layer;
    // console.log('Switch Display Level: ', this.tool.layerLevel);
  }

}
